<template>
    <div>
        <form>
            <stepper-step :number="0" :next-enabled="nextEnabledClientSelection">
                <client-selection
                    :preselected-client="preselectedClient">
                </client-selection>
            </stepper-step>

            <stepper-step :number="1" :checkBeforeGoToNext="checkFormFields" :previous-disabled="disableFormFieldBackButton">
                <user-form-fields :client="selectedClient" :key="selectedClient.id" :formerrors="formerrors" v-model="userFormFields">
                </user-form-fields>
            </stepper-step>

            <stepper-step :number="2" :checkBeforeGoToNext="checkUserAssignmentFormFields" :previous-disabled="disableAssignmentBackButton">
                <assignment-stepper-form :clientId="selectedClient.id" :key="selectedClient.id" :isUserCreate="true" :assignFormerrors="assignFormerrors" v-model="userCourseAssignmentFormFields">
                </assignment-stepper-form>
            </stepper-step>

            <stepper-step is-last-step :number="3">
                <user-create-summary
                    :client="selectedClient"
                    :key="selectedClient.id"
                    :userFormFields="userFormFields"
                    :userCourseAssignmentFormFields="userCourseAssignmentFormFields"
                    :isLastStep="true"
                >
                </user-create-summary>
            </stepper-step>

        </form>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    props: {
        preselectedClient: Object,
    },

    data() {
        return {
            selectedClient: this.preselectedClient,
            formerrors: {},
            assignFormerrors: {},
            userFormFields: {},
            userCourseAssignmentFormFields: {},
            disableFormFieldBackButton: false,
            disableAssignmentBackButton: false,
        }
    },
    computed: {
        skipFirstStep() {
            // A preselected client exists
            return !!this.preselectedClient.id;
        },

        nextEnabledClientSelection() {
            return this.selectedClient.hasOwnProperty('id') && this.selectedClient.id != 0;
        },
    },
    methods: {
        checkFormFields() {
            var postObject = this.getUserFormFieldsPostObject();

            return axios.post(this.route('tenantapi.users.validate'), postObject)
                .then(response => {
                    this.disableFormFieldBackButton = false;
                    this.formerrors = {};
                    return true;
                })
                .catch((error) => {
                    this.formerrors = error.response.data.errors;
                    this.disableFormFieldBackButton = true;
                    return false;
                });
        },

        checkUserAssignmentFormFields() {
            var user_groups =  this.formatUserGroupsForBackend();
            var courses = this.formatUserCoursesForBackend();

            return axios.post(this.route('tenantapi.users.course.assignment.validate'), {'user_groups': user_groups, 'courses': courses, 'client_id':this.selectedClient.id})
                .then(response => {
                    this.assignFormerrors = {};
                    this.disableAssignmentBackButton = false;
                    return true;
                })
                .catch((error) => {
                    this.assignFormerrors= error.response.data.errors;
                    this.disableAssignmentBackButton = true;
                    return false;
                });
        },

        submitForm() {
            var postObject = this.getUserFormFieldsPostObject();

            axios
                .post(this.route('tenant.users.store'), postObject)
                .then(this.handleResponse)
                .catch(({response}) => {
                    this.errors = response.data.errors;
                });
        },

        handleResponse(response) {
            if (response.status == 200) {
                this.flash({message: this.trans('users.flash.created'), level: 'success'});
                location.href = this.route('tenant.users.index');
            }
        },

        formatUserGroupsForBackend() {
            var user_groups =  [];

            Object.entries(this.userCourseAssignmentFormFields).forEach(([key, val]) => {
                if (key == 'userGroups') {
                    val.forEach((e,index) => {
                        user_groups[index] = {};
                        user_groups[index].user_group_id = e.userGroup ? e.userGroup.user_group_id : null
                        if (e.userGroup.courses.length !== 0) {
                            user_groups[index].client_id = e.client ? e.client.value : null
                            user_groups[index].start_date = e.startDate ? e.startDate : null;
                            user_groups[index].end_date = e.endDate ? e.endDate : null
                        }
                    });
                }
            });

            return user_groups;
        },

        formatUserCoursesForBackend() {
            var courses = [];

            Object.entries(this.userCourseAssignmentFormFields).forEach(([key, val]) => {
                if (key == 'courses') {
                    val.forEach((e,index) => {
                        courses[index] = {};
                        courses[index]['course_id'] = e.course ? e.course.value : null;
                        courses[index]['client_id'] = e.client ? e.client.value : null;
                        courses[index]['start_date'] = e.startDate ? e.startDate : null;
                        courses[index]['end_date'] = e.endDate ? e.endDate : null;
                    });
                }
            });

            return courses;
        },

        getUserFormFieldsPostObject() {
            var userGroups = this.formatUserGroupsForBackend();
            var courses= this.formatUserCoursesForBackend();
            var postObject = {
                    'client_id': this.selectedClient.id,
                    'internal_id': this.userFormFields.internal_id,
                    'roles': this.userFormFields.roles,
                    'gender': this.userFormFields.gender,
                    'title': this.userFormFields.title,
                    'firstname': this.userFormFields.firstname,
                    'lastname': this.userFormFields.lastname,
                    'street': this.userFormFields.street,
                    'zip': this.userFormFields.zip,
                    'city': this.userFormFields.city,
                    'email': this.userFormFields.email,
                    'username': this.userFormFields.username,
                    'user_groups': userGroups,
                    'courses': courses
                }

            var sufObject = {};
            Object.entries(this.userFormFields.specificUserFields).forEach(([key, val]) => {
                sufObject[val['key']] = val['value'];
            });
            postObject.specific_user_fields = sufObject;

            return postObject;
        }
    },

    mounted() {
        if(this.skipFirstStep) {
            EventBus.$emit('changeStepperTo', 1);
        }

        Event.$on('change-client-selection', (client) => {
            this.selectedClient = client;
        });

        EventBus.$on('submitForm', () => {
            this.submitForm();
        });
    },

};
</script>
